module.exports = __webpack_public_path__ + "static/media/gemini.a1358e2c.svg";